import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { TypingContent } from 'widgets/ConversationMessages/ui/TypingContent/TypingContent'
import { useConversationMessagesContext } from 'widgets/ConversationMessages/context'
import { ConversationHeader } from 'widgets/ConversationMessages/ui/ConversationHeader/ConversationHeader'
import { ConversationContent } from 'widgets/ConversationMessages/ui/ConversationContent/ConversationContent'
import { ConversationMessageField } from 'widgets/ConversationMessages/ui/ConversationMessageField/ConversationMessageField'
import { EmptyConversationsState } from 'widgets/ConversationMessages/ui/EmptryConversationsState/EmptyConversationsState'
import styles from './styles.module.scss'

export const ConversationMessagesSection = observer(() => {
  const { conversationStore, usersStore, integrationsStore } = useEntitiesContext()
  const store = useConversationMessagesContext()
  const { isConversationNew } = store

  useEffect(() => {
    usersStore.initUsersOrganization()
    integrationsStore.calendlyIntegrationStateStore.fetchCalendlyIntegrationState()
  }, [])

  const header = useMemo(() => {
    if (isConversationNew) return store.config?.renderCustomHeader?.()

    return <ConversationHeader />
  }, [isConversationNew])

  if (conversationStore.isEmpty && store.hasSearchParams) return <EmptyConversationsState />

  return (
    <div className={styles.wrap}>
      {header}
      <>
        <ConversationContent />
        <TypingContent />
        <ConversationMessageField inboxId={store.inboxId || undefined} />
      </>
    </div>
  )
})
